import Admin from "../Admin";
import React from "react";
import CardAdminOrderActivityTypeList from "../../../Component/Card/Admin/OrderActivityType/CardAdminOrderActivityTypeList";
import PageHeader from "../../../Component/PageHeader";
import MUIButton from "@mui/material/Button";
import MUIAddIcon from "@mui/icons-material/Add";

export default class AdminOrderActivityTypeList extends Admin {
  /**
   * Render the content.
   */
  renderContent() {
    return <CardAdminOrderActivityTypeList />;
  }

  renderHeader() {
    const handleClickCreate = () => {
      this.props.history.push({
        pathname: "/admin/orderActivityType",
      });
    };

    const buttons = [
      <MUIButton
        component="label"
        variant="contained"
        startIcon={<MUIAddIcon />}
        onClick={handleClickCreate}
      >
        Create New
      </MUIButton>,
    ];

    return <PageHeader title="Order Activity Types" buttons={buttons} />;
  }
}
